import axios from "axios";
// export const basePath = '/proxy-api-http/api';//本地代理
export const basePath = 'https://newapp.partyday.vip/index.php/api';


const request = axios.create();

// 设置请求拦截器，每次请求动态获取 token
request.interceptors.request.use(config => {
    const token = localStorage.getItem('satoken'); // 每次请求动态获取 token
    if (token) {
        config.headers['token'] = token;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
}, error => {
    return Promise.reject(error);
});

const http = {
    path(_path) {
        return basePath + _path;
    },
    get(path, data) {
        return request.get(this.path(path), {
            params: data
        });
    },
    post(path, data) {
        return request.post(this.path(path), data);
    }
};

export default http;